import React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import { ehEquipeBusifarm } from "../usersUtils";
import { resumoDasVisoes } from "../portalUtils";

/**
 * Coluna "Portal" da lista de usuários (BBF-179): se a pessoa entra no portal do cliente e com quais
 * visões. Estreita e quebrando linha, para a tabela continuar legível no celular.
 */
export default function PortalNaLista({ conta }) {
    if (ehEquipeBusifarm(conta?.specialAccessType)) {
        return <Typography variant="caption" color="text.secondary">Equipe Busifarm</Typography>;
    }
    if (!conta?.acessoPortal) {
        return <Typography variant="caption" color="text.secondary">Sem acesso</Typography>;
    }
    return (
        <Stack spacing={0.5} alignItems="flex-start" sx={{ maxWidth: 180 }}>
            <Chip label="Liberado" color="success" size="small" variant="outlined" />
            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.3 }}>
                {resumoDasVisoes(conta.visoesPortal)}
            </Typography>
        </Stack>
    );
}
